<template>
  <div style="background: #f0f4f7;padding-top: 140px;" >
<!--    <AboutBanner :content="banners.find(item=>item.id === 113).details"
                 :title="banners.find(item=>item.id === 113).title"
                 :img="banners.find(item=>item.id === 113).photo_file"/>-->
    <BlockCatalogue/>
    <BuildStructure/>
    <BlockArticles/>
    <BlockCertificates/>

<!--    <about-title title="محاسبات بلوک سبک" page-route="/sub/light-blocks/technical/calculator"/>-->
    <LightBlockLocalCalculator/>
<!--    <div v-if="scrolled" class="feature-box">
      <h4 class="text-decoration-underline font-weight-bold">Features</h4>
      <h6 v-for="(item,index) in scrollItems" :key="index"
          @click="handleChangeCat(index)"
          @mouseover="hoverTitle(index)"
          @mouseleave="scrollHover=null"
          :class="[scrollStatus===index?'green&#45;&#45;text font-weight-bold':'','mt-4 pointer']">
        {{
          scrollStatus === index ? scrollItems[index] : scrollHover !== null && scrollHover === index ? scrollItems[scrollHover] : `0${index + 1}`
        }}
      </h6>
    </div>-->
  </div>
</template>

<script>
import BuildStructure from "./BuildStructure/BuildStructure";
import BlockCatalogue from "./Catalogue/BlockCatalogue";
import BlockArticles from "./articles/BlockArticles";
import BlockCertificates from "./certificates/BlockCertificates";
import AboutBanner from "../About/Components/AboutBanner";
import AboutTitle from "../About/Components/AboutTitle";
import {mapState} from "vuex";

export default {
  name: "BaseTechnical",
  components: {
    AboutTitle,
     AboutBanner, BlockCertificates, BlockArticles, BlockCatalogue, BuildStructure
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.banners == null) {
      this.$store.dispatch('lightBlocksManagement/getBlockBanners');
    }
    this.$store.dispatch('lightBlocksManagement/getBlockArticles');
    this.$store.dispatch('lightBlocksManagement/getBlockHomeCatalogue');
    this.$store.dispatch('lightBlocksManagement/getBlockCertificates');
  },
  computed: {
    ...mapState({
      banners: state => state.lightBlocksManagement.blockBanners,
      certificates: state => state.lightBlocksManagement.blockCertificates,
      catalogues: state => state.lightBlocksManagement.blockHomeCatalogue,
      articles: state => state.lightBlocksManagement.blockArticles,
    })
  },
  data() {
    return {
      lastPosition: 0,
      scrollStatus: 0,
      scrollHover: null,
      limitPosition: 200,
      scrolled: false,
      scrollItems: [
        'کاتالوگ ها',
        'مقالات',
        'گواهینامه ها',
        'نحوه اجرای بلوک سبک',
        'محاسبات بلوک سبک'
      ]
    }
  },
  methods: {
    hoverTitle(index) {
      this.scrollHover = index;
    },
    checkPosition() {
      let cataloguesLength = Math.ceil(this.catalogues.topics.length/2);
      let articlesLength = this.articles.topics.length;
      let certificatesLength = Math.ceil(this.certificates.topics.length/2);
      if (window.scrollY > (cataloguesLength * 250) + (articlesLength * 180) + certificatesLength * 250+1000+700) {
        this.scrolled = false;
      } else if (this.limitPosition < window.scrollY) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
    handleScroll() {
      this.checkPosition();
      let cataloguesLength = Math.ceil(this.catalogues.topics.length/2);
      let articlesLength = this.articles.topics.length;
      let certificatesLength = Math.ceil(this.certificates.topics.length/2);
      if (window.scrollY > (cataloguesLength * 250) && window.scrollY < (cataloguesLength * 250) + (articlesLength * 180)) {
        this.scrollStatus = 1;
      } else if (window.scrollY > (cataloguesLength * 250) + (articlesLength * 180)) {
        this.scrollStatus = 2;
      }else if (window.scrollY > (cataloguesLength * 250) + (articlesLength * 180)+1000) {
        this.scrollStatus = 3;
      }else if (window.scrollY > (cataloguesLength * 250) + (articlesLength * 180)+1000+700) {
        this.scrollStatus = 4;
      } else if (window.scrollY < (cataloguesLength * 250)) {
        this.scrollStatus = 0;
      }
    },
    handleChangeCat(index) {
      let cataloguesLength = Math.ceil(this.catalogues.topics.length/2);
      let articlesLength = this.articles.topics.length;
      let certificatesLength = Math.ceil(this.certificates.topics.length/2);
      if (index === 0) {
        window.scrollTo(0, 400);
        this.scrollStatus = 0;
      } else if (index === 1) {
        this.scrollStatus = 1;
        window.scrollTo(0, (articlesLength * 180) - 100);
      } else if (index === 2) {
        this.scrollStatus = 2;
        window.scrollTo(0, ((certificatesLength + articlesLength) * 250 + 300));
      }else if (index === 3) {
        this.scrollStatus = 3;
        window.scrollTo(0, ((cataloguesLength * 250) + (articlesLength * 180)+1000));
      }else if (index === 4) {
        this.scrollStatus = 4;
        window.scrollTo(0, ((cataloguesLength * 250) + (articlesLength * 180)+1000+700));
      }
    }
  }
}
</script>

<style scoped>

</style>